/* global singleProductImages */
import _ from "underscore";
import * as globals from "./globals";
var functions = require("./filter.js");
let parse = require("./parse.js");
let tracking = require("./tracking.js");

function whichTransitionEvent() {
  var el = document.createElement("fake"),
    transEndEventNames = {
      WebkitTransition: "webkitTransitionEnd", // Saf 6, Android Browser
      MozTransition: "transitionend", // only for FF < 15
      transition: "transitionend", // IE10, Opera, Chrome, FF 15+, Saf 7+
    };

  for (var t in transEndEventNames) {
    if (el.style[t] !== undefined) {
      return transEndEventNames[t];
    }
  }
}
var transEndEventName = whichTransitionEvent();

export const getOffset = (el) => {
  let rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let top = rect.top > rect.height ? rect.top - rect.height : rect.top;
  return { top: top + scrollTop, left: rect.left + scrollLeft };
};

export const preloader = (state) => {
  var target;
  target = document.getElementById("grid");
  if (state) {
    target.style.position = "relative";
    var preload = document.createElement("div");
    var inner = document.createElement("div");
    var lineOne = document.createElement("span");
    var lineTwo = document.createElement("span");
    var icon = document.createElement("span");
    var img = document.createElement("img");
    preload.id = "preload";
    preload.style.cssText =
      "display:none;position:absolute;z-index:99999999999;top:35px;left:15px;width:100%;height:100%;text-align:center;";
    inner.className = "loading-wrapper";
    inner.style.cssText =
      "position:relative;display:table-cell;vertical-align:middle;";
    lineOne.className = "line";
    lineTwo.className = "line";
    icon.id = "loading";
    img.src = globals.wp_base + "wp-content/themes/posterclub/img/712.GIF";
    img.style.width = "25px";
    img.style.height = "auto";

    icon.appendChild(img);

    inner.appendChild(lineOne);
    inner.appendChild(icon);
    inner.appendChild(lineTwo);

    preload.appendChild(inner);
    target.appendChild(preload);
  } else {
    var preload = document.getElementById("preload");
    if (preload) {
      target.removeChild(preload);
    }
  }
};

export const waypoint = () => {
  if (jQuery("html").hasClass("no-touchevents")) {
    //console.log('desktop no mobil');
    let waypoint = new Waypoint({
      element: document.getElementById("filter-waypoint"),
      offset: 100,
      handler: (direction) => {
        direction == "up"
          ? (jQuery(".filter-wrapper").removeClass("stuck"),
            jQuery("#grid").removeClass("top-spacing"))
          : (jQuery(".filter-wrapper").addClass("stuck"),
            jQuery("#grid").addClass("top-spacing"));
        //console.log('direction', direction, jQuery(window).scrollTop());
      },
    });
    return waypoint;
  }
};

export const blazy = () => {
  var bLazy = new Blazy({
    offset: 0,
    success: (ele) => {
      //console.log('succcesss blazy');
    },
    error: (ele, msg) => {
      //console.log('blazy error', msg);
      if (msg == "missing") {
        jQuery(ele).removeClass("b-error");
        jQuery(ele).attr("data-src", jQuery(ele).attr("data-url"));
        bLazy.load(ele);
      }
    },
  });
  return bLazy;
};

export const removeArrow = () => {
  jQuery(".filter-item-wrapper .dropdown").on("scroll", (e) => {
    let parent = jQuery(e.currentTarget).parents(".filter-item-wrapper");
    if (
      jQuery(e.currentTarget).scrollTop() +
        jQuery(e.currentTarget).innerHeight() >=
      jQuery(e.currentTarget)[0].scrollHeight
    ) {
      jQuery(".filter-item", parent).addClass("bottom");
    } else {
      jQuery(".filter-item", parent).removeClass("bottom");
    }
  });
};

export const toggleSidebar = () => {
  jQuery("body").hasClass("menu-hover")
    ? (jQuery("body").removeClass("menu-hover"),
      jQuery(".click-div").css("display", "none"))
    : null;
};

export const toggleFilter = () => {
  window.addEventListener("mouseup", (event) => {
    let filter = jQuery(".filter-item");
    if (
      !jQuery(event.target).hasClass("filter-item") &&
      !jQuery(event.target.parentNode).hasClass("filter-item")
    ) {
      jQuery(".filter-item-wrapper.active").removeClass("active");
      jQuery(".filter-item.arrow").removeClass("active");
    }
  });
  jQuery(".filter-item").on("click", (e) => {
    let currTarget = e.currentTarget;
    let target = jQuery(e.currentTarget).parent(".filter-item-wrapper");
    let dropdown = jQuery(".dropdown", target);
    jQuery(".filter-item-wrapper.active").not(target).removeClass("active");
    jQuery(".filter-item.arrow")
      .not(e.currentTarget)
      .removeClass("arrow bottom");
    jQuery(target).toggleClass("active");
    let max = 9;
    let li = jQuery("li", dropdown)[0];
    let liHeight = jQuery(li).height();
    let liLength = jQuery("li", dropdown).length;
    if (max < liLength) {
      jQuery(currTarget).toggleClass("arrow");
      jQuery(dropdown).one(transEndEventName, (e) => {});
    }
  });
};

export const fetchSearch = (object) => {
  jQuery("#product-search, #mobile-search").submit((e) => {
    e.preventDefault();
    let form = jQuery(e.currentTarget);
    let newProducts = [];
    let search;
    search = jQuery("input[name=s]", form).val().toLowerCase();
    newProducts = functions.filterSearch(object.state.allProducts, search);
    //console.log('any new products', newProducts);
    !_.isEqual(newProducts, object.state.products)
      ? (jQuery(".b-lazy").removeClass("b-error b-loaded"),
        object.setState({
          products: newProducts,
          search: true,
          searchTerm: search,
        }))
      : null;
    jQuery("body").hasClass("menu-hover")
      ? (jQuery("body").removeClass("menu-hover"),
        jQuery(".click-div").css("display", "none"),
        jQuery("input[name=s]", form).blur())
      : (jQuery("input[name=s]", form).blur(),
        jQuery("#close-esc").removeClass("open"));
    window.history.pushState(null, null, "?s=" + search);
    jQuery("input[name=s]", form).val("");
    tracking.search(search);
    return object;
  });
};

/**
 * Checks if a product is a wall-object based on various input types
 * @param {Object|HTMLElement|boolean|null} productOrElement - Product object with categories, DOM element, boolean, or null
 * @returns {boolean} True if the product is a wall-object, false otherwise
 */
export const isWallObject = (productOrElement) => {
  // Handle null/undefined
  if (!productOrElement) {
    return false;
  }

  // Handle boolean (for global variable case)
  if (typeof productOrElement === "boolean") {
    return productOrElement;
  }

  // Handle DOM element (for app.js cases)
  if (productOrElement instanceof HTMLElement) {
    return productOrElement.classList.contains("product_cat-wall-objects");
  }

  // Handle product object with categories array or categorySlugs
  // Prefer categorySlugs (new lightweight format), fallback to categories (old format)
  if (
    productOrElement.categorySlugs &&
    Array.isArray(productOrElement.categorySlugs)
  ) {
    return productOrElement.categorySlugs.includes("wall-objects");
  }

  if (
    productOrElement.categories &&
    Array.isArray(productOrElement.categories)
  ) {
    return (
      productOrElement.categories.find(
        (category) => category && category.slug === "wall-objects",
      ) !== undefined
    );
  }

  return false;
};

export const handleMobileHistory = (history) => {
  jQuery("#sidebar").on("change", ".filter-select", (e) => {
    //console.log('something changed', e.currentTarget);
    let val = jQuery("option:selected", e.currentTarget).val();
    //console.log('selected value', val);
    jQuery(e.currentTarget).prop("selectedIndex", 0);
    history.pushState(null, val);
    window.location.hash = parse.randomHash();
    jQuery("body").hasClass("menu-hover")
      ? (jQuery("body").removeClass("menu-hover"),
        jQuery(".click-div").css("display", "none"))
      : null;
  });
};

export function initBlankwallAR() {
  if (!document.body.classList.contains("single-product")) return;

  const SCRIPT_ID = "blankwall-umd-cjs";
  const BLANKWALL_SRC =
    "https://dfv2bs0cn166o.cloudfront.net/blankwall.umd.cjs";
  const SIZE_LS_KEY = "spp:selected-size";
  const SIZE_BRIDGE_ATTR = "data-selected-size";
  const SHIPPING_ANCHOR = ".hidden.sm\\:block.w-full";
  const DEBUG_PREFIX = "[Blankwall]";
  const debug = (...args) => console.info(DEBUG_PREFIX, ...args);

  // Clear localStorage size on page load to prevent persistence between products
  try {
    localStorage.removeItem(SIZE_LS_KEY);
    debug("cleared localStorage size value on page load");
  } catch (e) {
    debug("failed to clear localStorage size value", e);
  }

  function loadBlankwall(cb) {
    debug("loadBlankwall: start");
    if (document.getElementById(SCRIPT_ID)) return cb();
    const s = document.createElement("script");
    s.id = SCRIPT_ID;
    s.async = true;
    s.src = BLANKWALL_SRC;
    s.onload = () => {
      debug("loadBlankwall: script loaded");
      cb();
    };
    document.head.appendChild(s);
  }

  function normalizeImageUrl(url) {
    if (!url) return "";
    url = url.replace(/-\d+x\d+(?=\.\w+$)/, "");
    try {
      const u = new URL(url, location.origin);
      u.search = "";
      return u.toString();
    } catch (_) {
      return url;
    }
  }

  function firstHeroImage() {
    const images =
      (typeof singleProductImages !== "undefined" &&
        Array.isArray(singleProductImages) &&
        singleProductImages) ||
      (typeof window !== "undefined" &&
        Array.isArray(window.singleProductImages) &&
        window.singleProductImages) ||
      [];
    if (images.length > 0) {
      const candidate = images[images.length - 1];
      const main = candidate && candidate.main;
      if (Array.isArray(main) && main[0]) {
        return {
          src: main[0],
          width: Number(main[1]) || 0,
          height: Number(main[2]) || 0,
          source: "vm",
        };
      }
    }
    const el = document.querySelector(
      ".woocommerce-product-gallery__image img, img.wp-post-image, img[src]",
    );
    if (!el) return null;
    return {
      src: el.currentSrc || el.src || el.getAttribute("src") || "",
      width:
        el.naturalWidth ||
        el.width ||
        Math.round(el.getBoundingClientRect().width),
      height:
        el.naturalHeight ||
        el.height ||
        Math.round(el.getBoundingClientRect().height),
      element: el,
      source: "dom",
    };
  }

  function getDimensionDefault() {
    const hero = firstHeroImage();
    const w = hero && hero.width ? hero.width : 0;
    const h = hero && hero.height ? hero.height : 0;
    if (w && h) {
      if (Math.abs(w - h) <= 2) return "50x50 cm";
      if (w > h) return "70x50 cm";
      return "50x70 cm";
    }
    return "50x70 cm";
  }

  function sanitizeSize(sizeStr) {
    if (!sizeStr || !sizeStr.trim()) return sizeStr;
    const trimmed = sizeStr.trim();

    // Check if size contains A1, A2, A3, or A4 pattern (e.g., "A4 (21x29,7 cm)")
    const aSizePattern = /A[1-4]\s*\(([^)]+)\)/i;
    const match = trimmed.match(aSizePattern);

    if (match && match[1]) {
      // Extract the measurement from parentheses (e.g., "21x29,7 cm")
      const measurement = match[1].trim();
      debug("sanitizeSize: extracted measurement from A-size", measurement);
      return measurement;
    }

    // No A-size pattern found, return as-is
    return trimmed;
  }

  function readSelectedSize() {
    // debug("readSelectedSize: checking localStorage + bridge attr");
    const fromLS = localStorage.getItem(SIZE_LS_KEY);
    if (fromLS && fromLS.trim()) {
      const sanitized = sanitizeSize(fromLS);
      if (sanitized) return sanitized;
    }

    const fromAttr = document.body.getAttribute(SIZE_BRIDGE_ATTR);
    if (fromAttr && fromAttr.trim()) {
      const sanitized = sanitizeSize(fromAttr);
      if (sanitized) return sanitized;
    }

    return getDimensionDefault();
  }

  function ensureHiddenImg() {
    debug("ensureHiddenImg: ensure hidden image exists");
    let img = document.querySelector("img.product-image");
    if (!img) {
      debug("ensureHiddenImg: no existing img.product-image, creating");
      img = document.createElement("img");
      img.className = "product-image";
      img.alt = "";
      img.style.display = "none";
      img.dataset.blankwallSource = "js";
      document.body.appendChild(img);
    } else {
      debug("ensureHiddenImg: reusing existing img.product-image");
      if (img.dataset.blankwallSource === "vm" && img.src) {
        debug(
          "ensureHiddenImg: server-provided image detected, skipping updates",
        );
        return img;
      }
    }
    const hero = firstHeroImage();
    if (hero && hero.src) {
      const normalized = normalizeImageUrl(hero.src);
      if (img.src !== normalized) {
        debug("ensureHiddenImg: updating src", normalized);
      }
      img.src = normalized;
      img.dataset.blankwallSource = hero.source || "js";
    }
    return img;
  }

  function ensureDims() {
    debug("ensureDims: ensure dimensions element exists");
    let dims = document.querySelector(".product-description");
    if (!dims) {
      dims = document.createElement("div");
      dims.className = "product-description";
      dims.style.display = "none";
      document.body.appendChild(dims);
    }
    dims.textContent = readSelectedSize();
    return dims;
  }

  function ensureContainerNear(anchorEl) {
    let container = document.getElementById("blankwall-container");
    if (!container) {
      container = document.createElement("div");
      container.id = "blankwall-container";
      container.style.marginTop = "1rem";
      if (anchorEl && anchorEl.parentNode) {
        anchorEl.parentNode.insertBefore(container, anchorEl.nextSibling);
      } else {
        document.body.appendChild(container);
      }
    }
    return container;
  }

  function waitForAnchor(selector, timeoutMs) {
    return new Promise((resolve, reject) => {
      let elapsed = 0;
      const step = 200;
      (function poll() {
        const el = document.querySelector(selector);
        if (el) return resolve(el);
        elapsed += step;
        if (elapsed >= timeoutMs) return reject(new Error("anchor-timeout"));
        setTimeout(poll, step);
      })();
    });
  }

  function initIfReady() {
    debug("initIfReady: checking prerequisites");
    const ok =
      window.Blankwall &&
      document.querySelector("#blankwall-container") &&
      document.querySelector("img.product-image[src]") &&
      document.querySelector(".product-description");
    if (!ok) return false;
    const isMobile =
      window.matchMedia && window.matchMedia("(max-width: 639px)").matches;
    const style = isMobile
      ? {
          buttonText: "View in Your Room",
          width: "100%",
          padding: "12px 16px",
          borderRadius: "0px",
        }
      : {
          buttonText: "View in Your Room",
        };

    window.Blankwall.init(
      {
        ar_container_selector: "#blankwall-container",
        ar_image_selector: "img.product-image",
        ar_dimensions_selector: ".product-description",
      },
      style,
    );
    return true;
  }

  function applyMobileButtonStyles() {
    const isMobile =
      window.matchMedia && window.matchMedia("(max-width: 639px)").matches;
    if (!isMobile) return;
    const container = document.getElementById("blankwall-container");
    const btn = document.querySelector(
      ".ar-button, #blankwall-container button, #blankwall-container a",
    );
    if (!container || !btn) return;
    container.style.width = "100%";
    btn.style.width = "100%";
    btn.style.borderRadius = "0px";
  }

  function startSync() {
    debug("startSync: setting up synchronize routines");
    const prod = document.querySelector("img.product-image");

    const updateImg = () => {
      const hero = firstHeroImage();
      if (hero && hero.src) {
        const clean = normalizeImageUrl(hero.src);
        if (clean && prod.src !== clean) {
          debug("startSync.updateImg: updating product image", clean);
          prod.src = clean;
        }
      }
    };
    updateImg();

    const sizeIv = setInterval(() => {
      const dims = document.querySelector(".product-description");
      if (!dims) return;
      const val = readSelectedSize();
      if (dims.textContent !== val) dims.textContent = val;
    }, 600);

    const target =
      document.querySelector(".woocommerce-product-gallery") || document.body;
    if (window.MutationObserver) {
      debug("startSync: using MutationObserver");
      const obs = new MutationObserver(() => {
        debug("startSync: mutation observed");
        updateImg();
        applyMobileButtonStyles();
      });
      obs.observe(target, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["src"],
      });
      window.addEventListener("unload", () => {
        obs.disconnect();
        clearInterval(sizeIv);
        debug("startSync: cleanup MutationObserver + intervals");
      });
    } else {
      debug(
        "startSync: MutationObserver unavailable, falling back to interval",
      );
      const iv = setInterval(() => {
        updateImg();
        applyMobileButtonStyles();
      }, 1000);
      window.addEventListener("unload", () => {
        clearInterval(iv);
        clearInterval(sizeIv);
        debug("startSync: cleanup fallback intervals");
      });
    }

    setTimeout(applyMobileButtonStyles, 0);
  }

  function boot() {
    debug("boot: waiting for anchor", SHIPPING_ANCHOR);
    waitForAnchor(SHIPPING_ANCHOR, 10000)
      .catch(() => waitForAnchor(".summary,.product,.cart", 5000))
      .then((anchor) => {
        debug("boot: anchor found", anchor && anchor.className);
        ensureContainerNear(anchor);
        ensureHiddenImg();
        ensureDims();
        let tries = 0;
        const iv = setInterval(() => {
          ensureHiddenImg();
          ensureDims();
          if (initIfReady() || ++tries > 20) {
            clearInterval(iv);
            startSync();
          } else {
            applyMobileButtonStyles();
          }
        }, 250);
      })
      .catch(() => {
        debug("boot: failed to find anchor, using fallback");
        ensureContainerNear(document.body);
        ensureHiddenImg();
        ensureDims();
        if (initIfReady()) {
          startSync();
        }
      });
  }

  loadBlankwall(() => setTimeout(boot, 0));
}

jQuery(() => {
  const wallObjectProduct = document.querySelector(".product_cat-wall-objects");
  const frameProduct = document.querySelector(".product_cat-frames");
  const passepartoutProduct = document.querySelector(
    ".product_cat-passepartout",
  );
  const canvasProduct = document.querySelector(".product_cat-canvas");

  if (
    wallObjectProduct ||
    frameProduct ||
    passepartoutProduct ||
    canvasProduct
  ) {
    return;
  }
  try {
    initBlankwallAR();
  } catch (_) {}
});
